import { checkSub, checkVisibleSubs } from './legacyBridge/legacyActions'
import { normalizeSubsSection } from './contracts/subsNavigation'
import type { SubsSelectionAction, SubsSelectionSection } from './contracts/subsSelection'
import { treeStore } from './state'
import { getMsgDeskRuntime } from './runtime/MsgDeskRuntime'

export * from './contracts/subsSelection'

export type SubsSelectionRequest = SubsSelectionAction & {
  section: SubsSelectionSection | 0 | 1
  target: unknown
}

function reconcileChecked(ids: number[], checked: boolean): void {
  const apply = () => ids.forEach(id => treeStore.mutate.setSubState(id, { isFlagBlue: checked }))
  apply()
  getMsgDeskRuntime().setTimeout(apply, 100)
}

export function dispatchSubsSelection(request: SubsSelectionRequest): unknown {
  const section = normalizeSubsSection(request.section)
  if (request.action === 'toggle-visible') {
    const sectionKey = section === 0 ? 'answers' : 'submsges'
    const ids = treeStore.getState().renderProjection.rootIds[sectionKey] || []
    const shouldCheck = ids.some(id => !treeStore.getState().subStates[id]?.isFlagBlue)
    const result = checkVisibleSubs(request.target, section)
    reconcileChecked(ids, shouldCheck)
    return result
  }
  const result = checkSub(request.target, request.elId, request.checked)
  reconcileChecked([request.elId], request.checked)
  return result
}
